import { render, staticRenderFns } from "./Utilizatori_penalizare_list.vue?vue&type=template&id=6c792413&scoped=true&"
import script from "./Utilizatori_penalizare_list.vue?vue&type=script&lang=js&"
export * from "./Utilizatori_penalizare_list.vue?vue&type=script&lang=js&"
import style0 from "./Utilizatori_penalizare_list.vue?vue&type=style&index=0&id=6c792413&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c792413",
  null
  
)

export default component.exports